import { render, staticRenderFns } from "./CallStaff.vue?vue&type=template&id=d3478d9e&scoped=true"
import script from "./CallStaff.vue?vue&type=script&lang=js"
export * from "./CallStaff.vue?vue&type=script&lang=js"
import style0 from "./CallStaff.vue?vue&type=style&index=0&id=d3478d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3478d9e",
  null
  
)

export default component.exports